"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PizzaCafeRequestBodyToJSON = exports.PizzaCafeRequestBodyFromJSONTyped = exports.PizzaCafeRequestBodyFromJSON = void 0;
function PizzaCafeRequestBodyFromJSON(json) {
    return PizzaCafeRequestBodyFromJSONTyped(json, false);
}
exports.PizzaCafeRequestBodyFromJSON = PizzaCafeRequestBodyFromJSON;
function PizzaCafeRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'level': json['level'],
    };
}
exports.PizzaCafeRequestBodyFromJSONTyped = PizzaCafeRequestBodyFromJSONTyped;
function PizzaCafeRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'level': value.level,
    };
}
exports.PizzaCafeRequestBodyToJSON = PizzaCafeRequestBodyToJSON;
